module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/schooltube_icon-053c3.png";